/**
 * Additional Programs catalog — marketing guide only.
 * Covers load from production media (SERVER_URL_IMG).
 */

export const MARKETING_ADDITIONAL_PROGRAMS_DISCLAIMER =
    'Important: The programs below were offered apart from the Framework in the legacy Oola shop. Before using them in USANA shop pages, bundles, or campaigns, confirm with Dave which programs will remain available, whether pricing changes, and how they map to the USANA offer.';

/** @typedef {{ title: string, description: string, coverPath?: string | null, coverFallbackPath?: string, coverLayout?: 'portrait' | 'landscape' }} MarketingAdditionalProgram */

/** @type {MarketingAdditionalProgram[]} */
export const MARKETING_ADDITIONAL_PROGRAMS = [
    {
        title: 'Green Gap',
        description:
            'Financial wellness — money mindset, budgeting, debt strategy, and closing the gap between income and an intentional Oola life.',
        coverPath: 'media/images/dashboard/Green_Gap_course.jpg',
        coverLayout: 'portrait',
    },
    {
        title: 'Oola Body by Design',
        description:
            'Body transformation program — sustainable fitness and nutrition habits aligned with the seven life areas.',
        coverPath: 'media/images/dashboard/Body_By_Design.jpg',
        coverLayout: 'portrait',
    },
    {
        title: 'The Miracle Mindset',
        description:
            'Mindset course — rewire limiting thoughts, daily mindset practices, and build emotional resilience.',
        coverPath: 'media/images/dashboard/Miracle_Mindset_course.jpg',
        coverLayout: 'portrait',
    },
    {
        title: '23 Strong — Phase 1',
        description:
            'First phase of the 23 Strong discipline program — mental toughness and habit strength (levels 2–8 unlock separately).',
        coverPath: 'media/images/dashboard/23 strong cover.jpg',
        coverFallbackPath: 'media/elearning/images/Phase 1 cover.jpg',
        coverLayout: 'portrait',
    },
    {
        title: 'Who Are You?',
        description:
            'Identity and self-discovery — clarify purpose, values, and direction before setting the next season of goals.',
        coverPath: 'media/images/dashboard/Who Are You_ COVER-long.jpg',
        coverFallbackPath: 'media/elearning/images/Who Are You_ COVER-long.jpg',
        coverLayout: 'landscape',
    },
    {
        title: 'Mind & Body Coach Certification',
        description:
            'Professional certification for members who want to coach others using the Oola Mind & Body methodology.',
        coverPath: 'media/elearning/images/M&B-Coach-Cover.jpg',
        coverLayout: 'landscape',
    },
    {
        title: 'Oola Coaching Certification',
        description:
            'Coach training track for members building an Oola coaching practice (separate from Mind & Body certification).',
        coverPath: null,
    },
];
